module.exports = __webpack_public_path__ + "img/e069.cdb89743.png";